import React, { useEffect, useState } from 'react';

export default function Toggle({ toggleOn = true, handleChange = () => {}, isSmall = false, toggleColor = null, disabled = false}) {
	const [toggleState, setToggleState] = useState(toggleOn);

	useEffect(() => {
		setToggleState(toggleOn);
	}, [toggleOn]);
	
	const selectToggle = () => {
		if(disabled) return;
		const new_state = !toggleState;
		
		setToggleState(new_state);
		handleChange(new_state);
	}
	
	return (
		<div className={`toggle-btn-container${isSmall ? '-small' : ''} ${toggleState ? `toggle-btn-container-selected${toggleColor ? `-${toggleColor}` : ''}` : ''} ${disabled ? 'disabled' : ''}`}>
			<div className={`${toggleState ? `toggle-btn-selected${isSmall ? '-small' : ''} ${toggleColor && `toggle-btn-border-${toggleColor}`}` : `toggle-btn-unselected${isSmall ? '-small' : ''}`}`} onClick={selectToggle}></div>
		</div>
	);
}
